const Consultant = () => import(/* webpackChunkName: "consultant" */ '@/views/private/consultant/Index.vue')
const Topic = () => import(/* webpackChunkName: "consultanttopic" */ '@/components/consultant/Topic.vue')
const Consult = () => import(/* webpackChunkName: "consultantconsult" */ '@/components/consultant/Consult.vue')

const routes = [
  {
    path: "/consultant",
    name: "consultant",
    component: Consultant,
    meta: {
      title: "Konsultasi"
    },
    children: [
      {
        path: "/consultant/topic",
        name: "consultant topic",
        component: Topic,
        meta: {
          title: "Topik"
        }
      },
      {
        path: "/consultant/consult",
        name: "consultant consult",
        component: Consult,
        meta: {
          title: "Konsultasi"
        }
      }
    ]
  }
]

export default routes.map(route => {
	const meta = {
		all: false, 
		public: false,
		title: route.meta.title
	}
	return { ...route, meta }
})